module.exports = __webpack_public_path__ + "static/media/english.b436aab5.png";